import { styled } from '@mui/material';

export const Container = styled('div')(({ theme }) => ({
  maxWidth: '1440px',
  margin: '0 auto',
  padding: theme.spacing(0, 2),
}));
